import { clearLocalStorage } from '@shiftnex/framework/src/libs/localStorage';
export { clearLocalStorage } from '@shiftnex/framework/src/libs/localStorage';

export function clearUserLocalData() {
  clearLocalStorage({ exclude: ['deviceId', 'ax_tenantId'] });
}
